<script setup lang="ts">
defineProps<{
  show: boolean;
}>();
</script>

<template>
  <div v-if="show" class="loading loading-lg">Loading...</div>
</template>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
